// English translations for recipes page
// Location: src/i18n/locales/en/recipes.ts

export const recipes = {
  title: 'Your Recipes',
  subtitle: 'All recipes from your meal plan',
  subtitleVip: 'Recipes from your {{count}}-day meal plan',
  subtitleBasic: 'Simple recipe descriptions from your plan',
  
  searchPlaceholder: 'Search recipes...',
  
  filters: {
    all: 'All',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    snack: 'Snack',
  },
  
  showing: 'Showing {{count}} recipes',
  clearFilters: 'Clear filters',
  noResults: 'No recipes found matching your search',
  
  day: 'Day {{day}}',
  minutes: 'min',
  
  emptyState: {
    title: 'No Recipes Yet',
    description: 'Create your nutrition plan to get personalized recipes tailored to your goals and preferences.',
    createPlan: 'Create My Plan with AI',
    infoTitle: 'What You\'ll Get',
    infoDescription: 'Once you create your nutrition plan, you\'ll have access to all your meal recipes in one place. Search, filter by meal type, and view detailed cooking instructions.',
  },
  
  vipInfo: {
    title: 'Upgrade to VIP for Detailed Recipes',
    description: 'With the VIP plan, you get step-by-step instructions with exact measurements, cooking times, and tips for every recipe!',
  },

  generating: 'Generating...',
  generatingTitle: 'Generating Recipe...',
  generatingDescription: "We're finding the perfect recipe for your meal. This will take about 5-10 seconds.",
  generatingButton: 'Generating Recipe...',
  generateButton: 'Generate Full Recipe',
  generationTime: 'Takes about 5-10 seconds',
  generationFailed: 'Generation Failed',
  tryAgain: 'Try Again',
  
  noRecipeTitle: 'No Recipe Yet',
  noRecipeDescription: "This meal doesn't have a detailed recipe yet. Generate one now to see ingredients, instructions, and more!",
  
  vipRequired: 'VIP Feature Required',
  vipRequiredDescription: 'Upgrade to VIP to generate detailed recipes with ingredients, step-by-step instructions, and more!',
  
  calories: 'Calories',
  kcal: 'kcal',
  servings: 'Servings',
  portions: 'portions',
  totalTime: 'Total Time',
  cuisine: 'Cuisine',
  
  nutritionalInfo: 'Nutritional Information',
  protein: 'Protein',
  carbs: 'Carbs',
  fat: 'Fat',
  
  ingredients: 'Ingredients',
  addToShoppingList: 'Add to shopping list',
  neverShowIngredient: 'Never show this ingredient',
  
  instructions: 'Instructions',
  viewFullRecipe: 'View Full Recipe & Instructions',
};